// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionStatusPage_root__1QNeL","dialog":"AuctionStatusPage_dialog__2lnU3","submitButton":"AuctionStatusPage_submitButton__1UKEp"};